export default {"src":"/_next/static/media/skin.7d6cae6e.svg","height":30,"width":30};